<div class="popup-dialog">
    <h3>
    Download report
</h3>

<div class="localid-dialog-content">
    <p class="subheading">
        Please click the preferred format to download.
    </p>
</div>
</div>

<div class="btn">
    <owc-button color="primary" (click)="selectFormat('csv')">CSV</owc-button>
    <owc-button color="primary" (click)="selectFormat('xlsx')">Excel</owc-button>
    <owc-button (click)="selectFormat(null)" class="cd-close">Cancel</owc-button>
  </div>